import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './useAuth';
import { hasRole } from './permissions';
import type { Role } from '../types/api';

export function RequireRole({ roles }: { roles: Role[] }) {
  const { user } = useAuth();

  if (!hasRole(user, ...roles)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
